module.exports = __webpack_public_path__ + "img/bg9.c050b5d8.jpg";